import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-page" }
const _hoisted_2 = { class: "container account-page__inner" }
const _hoisted_3 = { class: "account-page__card" }
const _hoisted_4 = { class: "account-page__setting" }
const _hoisted_5 = { class: "form-check form-switch" }
const _hoisted_6 = { class: "account-page__setting" }

import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import {
  notificationsEnabled,
  setNotificationsEnabled,
} from "@/composables/usePushNotifications";


export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const router = useRouter();
const notifications = ref(notificationsEnabled());
const language = ref("fa");

watch(notifications, async (enabled) => {
  const ok = await setNotificationsEnabled(enabled);
  if (enabled && !ok) notifications.value = false;
});

function goBack() {
  router.push("/dashboard");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "account-page__back",
        onClick: goBack
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "20",
          height: "20",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            d: "M5 12H19",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M13 6l6 6-6 6",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1),
        _createElementVNode("span", null, "بازگشت", -1)
      ]))]),
      _cache[6] || (_cache[6] = _createElementVNode("header", { class: "account-page__header" }, [
        _createElementVNode("p", { class: "account-page__eyebrow" }, "حساب کاربری"),
        _createElementVNode("h1", { class: "account-page__title" }, "تنظیمات"),
        _createElementVNode("p", { class: "account-page__subtitle" }, "ترجیحات خود را مدیریت کنید")
      ], -1)),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "account-page__setting-title" }, "اعلان‌ها"),
            _createElementVNode("p", { class: "account-page__setting-desc" }, "درخواست دوستی، دعوت اسپیکینگ و پیام‌های داخل برنامه")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "notifications",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((notifications).value = $event)),
              class: "form-check-input",
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, notifications.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "account-page__setting-title" }, "زبان"),
            _createElementVNode("p", { class: "account-page__setting-desc" }, "زبان نمایش برنامه")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((language).value = $event)),
            class: "form-select account-page__select"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("option", { value: "fa" }, "فارسی", -1),
            _createElementVNode("option", { value: "en" }, "انگلیسی", -1)
          ]))], 512), [
            [_vModelSelect, language.value]
          ])
        ])
      ])
    ])
  ]))
}
}

})